import { useEffect, useRef } from 'react'
import ButtonComponent from '../../stories/atoms/button'
import {
  buttonTypeOptions,
  buttonVariantOptions
} from '../../stories/atoms/button/constants'
import {
  ChevronRightSmall,
  ChevronLeftSmall
} from '../../stories/atoms/icons/essentials'
import {
  PaginationCount,
  ProjectPaginationContainer
} from '../styled-components'
import { useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

const ProjectInfoPanelPagination = ({
  projectDetails,
  projectTree,
  isLoading,
  isFetching,
  pageNumber,
  totalElements,
  pageSize,
  isFirstPage,
  isLastPage,
  onPageChange
}) => {
  const history = useHistory()

  const pendingEdgeNavigation = useRef(null)
  const currentProjectId = projectDetails?.id

  const projectIdList = projectTree?.map((item) => item.id) ?? []
  const currentProjectIndex = projectIdList.indexOf(currentProjectId)

  useEffect(() => {
    if (!pendingEdgeNavigation.current || isFetching) return
    if (!projectIdList.length) return

    const targetId =
      pendingEdgeNavigation.current === 'first'
        ? projectIdList[0]
        : projectIdList[projectIdList.length - 1]

    pendingEdgeNavigation.current = null
    if (targetId) history.push(`/project/info/${targetId}`)
  }, [projectIdList, isFetching])

  const navigateToProject = (id) => {
    if (id) history.push(`/project/info/${id}`)
  }

  const handlePrevious = () => {
    if (currentProjectIndex > 0) {
      navigateToProject(projectIdList[currentProjectIndex - 1])
    } else if (!isFirstPage && !isFetching) {
      pendingEdgeNavigation.current = 'last'
      onPageChange(pageNumber - 1)
    }
  }

  const handleNext = () => {
    if (
      currentProjectIndex > -1 &&
      currentProjectIndex < projectIdList.length - 1
    ) {
      navigateToProject(projectIdList[currentProjectIndex + 1])
    } else if (!isLastPage && !isFetching) {
      pendingEdgeNavigation.current = 'first'
      onPageChange(pageNumber + 1)
    }
  }

  const globalIndex = pageNumber * pageSize + currentProjectIndex

  const disablePreviousButton =
    isFetching || (currentProjectIndex <= 0 && isFirstPage)
  const disableNextButton =
    isFetching ||
    (currentProjectIndex === projectIdList.length - 1 && isLastPage)

  if (currentProjectIndex === -1 && !pendingEdgeNavigation.current) return null

  return (
    <ProjectPaginationContainer>
      <ButtonComponent
        buttonType={buttonTypeOptions['ICON-ONLY']}
        variant={buttonVariantOptions.GHOST}
        onClick={handlePrevious}
        disabled={disablePreviousButton}
      >
        <ChevronLeftSmall />
      </ButtonComponent>
      <PaginationCount>
        <FormattedMessage
          id="pagination_count"
          values={{
            current: isLoading || isFetching ? '-' : globalIndex + 1,
            total: isLoading ? '-' : totalElements
          }}
        />
      </PaginationCount>
      <ButtonComponent
        buttonType={buttonTypeOptions['ICON-ONLY']}
        variant={buttonVariantOptions.GHOST}
        onClick={handleNext}
        disabled={disableNextButton}
      >
        <ChevronRightSmall />
      </ButtonComponent>
    </ProjectPaginationContainer>
  )
}

ProjectInfoPanelPagination.propTypes = {
  projectDetails: PropTypes.object,
  projectTree: PropTypes.array,
  isLoading: PropTypes.bool,
  isFetching: PropTypes.bool,
  pageNumber: PropTypes.number,
  totalElements: PropTypes.number,
  pageSize: PropTypes.number,
  isFirstPage: PropTypes.bool,
  isLastPage: PropTypes.bool,
  onPageChange: PropTypes.func
}

export default ProjectInfoPanelPagination
